import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Footer from "../../components/Footer";
import ProductShowcase from "../../components/cultivars/FastOrange/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const FastOrange = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Fast Orange Cultivar - BeyondBloom™</title>
        <meta name="description" content="Discover Fast Orange, a high-quality cultivar from BeyondBloom™. Featuring vibrant citrus flavors and uplifting effects, it's a must-try strain." />
        <meta name="keywords" content="Fast Orange, cannabis, premium cultivar, BeyondBloom, high-quality strains, citrus strain, uplifting effects" />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Fast Orange Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Discover Fast Orange, a high-quality cultivar from BeyondBloom™. Featuring vibrant citrus flavors and uplifting effects, it's a must-try strain." />
        <meta property="og:image" content="/images/fast-orange.png" />
        <meta property="og:url" content="https://yourwebsite.com/fast-orange" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fast Orange Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Discover Fast Orange, a high-quality cultivar from BeyondBloom™. Featuring vibrant citrus flavors and uplifting effects, it's a must-try strain." />
        <meta name="twitter:image" content="/images/fast-orange.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default FastOrange;
